import React, {Component} from 'react'
import {Col, Row} from "reactstrap";
import {Input, message, Modal} from "antd";
import {ApiService} from "../services/ApiService1";


class ResetPasswordModal extends Component {
    state = {
        password: '',
        confirmPassword: '',
        isResetting: false
    }

    onChange = (event) => {
        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }

    onResetPassword = async () => {
        const { userName, isSelf } = this.props
        const { password, confirmPassword } = this.state
        this.setState({
            isResetting: true
        })
        let response = ""
        // const response = await ApiService.changePassword({password, confirmPassword})
        if(isSelf) {
            response = await ApiService.changePassword({password, confirmPassword})
        } else {
            response = await ApiService.resetPasswordForUser(userName, { password })
        }
        if (!response || response.error) {
            this.setState({
                isResetting: false
            })
            return message.error('something is wrong! please try again');
        } else {
            message.success('password reset successfully');
            this.setState({
                isResetting: false,
                password: "",
                confirmPassword: ""
            })
            this.props.onClose(true)
        }
    }

    render() {
        const { onClose } = this.props
        const { password, confirmPassword, isResetting } = this.state
        return(
            <div>
                <Modal
                    onCancel={() => onClose(false)}
                    onOk={this.onResetPassword}
                    visible={true}
                    title="Reset Password"
                    okButtonProps={{disabled: !(password && confirmPassword && (password === confirmPassword)) || isResetting, loading: isResetting}}
                >
                    <div>
                        <Row>
                            <Col md={12} sm={12} xs={12}>
                                <form className="form">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">New Password</span>
                                        <div className="form__form-group-field">
                                            <Input type="password" name="password" value={password} onChange={this.onChange} />
                                        </div>
                                    </div>
                                </form>
                            </Col>
                            <Col md={12} sm={12} xs={12}>
                                <form className="form">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Confirm Password</span>
                                        <div className="form__form-group-field">
                                            <Input type="password" name="confirmPassword" value={confirmPassword} onChange={this.onChange} />
                                        </div>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        )
    }
}


export default ResetPasswordModal